<template>
  <section class="space-y-4">
    <h2 class="text-base font-medium dark:text-gray-100">
      {{ t("pages.fitrana.calculator.title") }}
    </h2>

    <p class="text-base text-gray-600 dark:text-gray-300 leading-relaxed">
      {{ t("pages.fitrana.calculator.description") }}
    </p>

    <div
      class="divide-y dark:divide-gray-700 rounded-lg border border-gray-200 dark:border-gray-700"
    >
      <div
        v-for="count in members"
        :key="count"
        class="flex justify-between px-4 py-3 text-base"
      >
        <span>
          {{ count }} {{ t("pages.fitrana.calculator.membersLabel") }}
        </span>
        <span class="font-semibold dark:text-gray-100">
          {{ t("pages.fitrana.amount.currency") }} {{ count * amount }}
        </span>
      </div>
    </div>

    <p class="text-xs text-gray-500 dark:text-gray-400">
      {{ t("pages.fitrana.calculator.moreNote") }}
    </p>
  </section>
</template>

<script setup lang="ts">
const { t } = useI18n();

defineProps<{
  amount: number;
}>();

const members = [3, 4, 5, 6, 7];
</script>
